import * as Yup from "yup";

export function validation(translation, id) {
  return Yup.object({
    name: Yup.string(translation("common:errors.invalid"))
      .required(translation("common:errors.required"))
      .nullable(),
    email: Yup.string(translation("common:errors.invalid"))
      .required(translation("common:errors.required"))
      .email(translation("common:errors.invalid")),
    password: id
      ? Yup.string()
          .min(8, "Senha está muito curta - deve ter 8 caracteres no mínimo.")
          .nullable()
      : Yup.string().min(
          8,
          "Senha está muito curta - deve ter 8 caracteres no mínimo."
        ),
    passwordConfirmation: id
      ? Yup.string()
          .oneOf([Yup.ref("password")], "Senhas precisam ser iguais")
          .nullable()
      : Yup.string().oneOf([Yup.ref("password")], "Senhas precisam ser iguais"),
    phone1: Yup.string(translation("common:errors.invalid"))
      .test(
        "isRequiredPhoneNumber",
        translation("common:errors.required"),
        (value, testContext) => {
          return (
            (value && value.replace(/^\+\d*\s*/, "")) ||
            testContext.parent.emailContact
          );
        }
      )
      .nullable(),
  });
}
